import { useCallback, useContext, useEffect, useState } from 'react';
import { permissionsInstanceSetup } from './permissionsChecker';
import { PermissionsContext } from './PermissionsProvider';
const permissionsMap = new Map();
const hash = (str) => {
    let hash = 0, chr;
    for (let i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
};
export const usePermissions = (permission) => {
    const [hasPermission, setHasPermission] = useState(undefined);
    const [error, setError] = useState(undefined);
    const { shouldReload } = useContext(PermissionsContext);
    if (!permission) {
        return {
            error: { name: 'no-permission', message: 'Permission not defined' },
            loading: false,
            hasPermission: true,
        };
    }
    const { resource, action } = permission;
    const permissionKey = hash(resource + action);
    const loadPermissions = useCallback(() => {
        let didCancel = false;
        const fetchPermissions = async () => {
            try {
                const permissionInstance = permissionsInstanceSetup.getInstance();
                const permissionsCheck = await permissionInstance.checkPermission(resource, action);
                if (!didCancel) {
                    permissionsMap.set(permissionKey, permissionsCheck);
                    setHasPermission(permissionsCheck);
                }
            }
            catch (e) {
                console.log('usePermissions error: ', e);
                if (!didCancel) {
                    setError(e);
                }
            }
        };
        const cachedPermission = permissionsMap.get(permissionKey);
        if (typeof cachedPermission !== 'undefined') {
            setHasPermission(cachedPermission);
        }
        else {
            fetchPermissions();
        }
        return () => {
            didCancel = true;
        };
    }, []);
    const reload = useCallback(async () => {
        const permissionInstance = permissionsInstanceSetup.getInstance();
        await permissionInstance.reload();
        permissionsMap.clear();
        loadPermissions();
    }, []);
    useEffect(() => {
        return loadPermissions();
    }, []);
    useEffect(() => {
        if (shouldReload) {
            loadPermissions();
        }
    }, [shouldReload]);
    return {
        called: hasPermission !== undefined,
        error,
        hasPermission,
        loading: hasPermission === undefined,
        reload,
    };
};
//# sourceMappingURL=usePermissions.js.map